import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { MaxFileSize, validateMaxFileSize } from '@core/utils-legacy';

import type { TrackableFile, WysiwygUploader } from './upload.types';

export type ImageDimensions = Observable<{ width: number; height: number; src: string }>;

// TODO
//  TBD reuse those helpers in Redactor

export const getImageDimensionsFromFile = (file: File): ImageDimensions =>
  imageLoader(URL.createObjectURL(file)).pipe(
    map(image => ({
      width: image.naturalWidth,
      height: image.naturalHeight,
      src: image.src,
    })),
  );

export const getImageDimensionsFormUrl = (url: string): ImageDimensions =>
  imageLoader(url).pipe(
    map(image => ({
      width: image.naturalWidth,
      height: image.naturalHeight,
      src: image.src,
    })),
  );

export const imageLoader = (src: string): Observable<HTMLImageElement> =>
  new Observable(observer => {
    const img = new Image();

    img.onload = () => {
      observer.next(img);
      observer.complete();
    };

    img.onerror = event => {
      observer.error(event);
    };

    img.src = src;
  });

export function uploadFactory(uploader: WysiwygUploader) {
  return function <S extends TrackableFile>({ id, url, file, type, visibility, ...rest }: S) {
    return uploader.upload(file, visibility).pipe(
      map(({ upload }) => ({
        url: upload.fileUrl,
        guid: upload.guid,
        id,
        file,
        type,
        ...rest,
      })),
      catchError(error =>
        of({
          url,
          id,
          file,
          type,
          error,
        }),
      ),
    );
  };
}

export const dataURLtoFile = (dataurl: string, filename: string): File => {
  const [meta, base64] = dataurl.split(',');
  const mime = meta.match(/:(.*?);/)![1];
  const bstr = atob(base64);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};

export const validImageSizeFilter = (file: File) => validateMaxFileSize(file, MaxFileSize.File50MB);
